import { useContent } from "../../context/ContentContext";

export const Marquee = () => {
  const { content } = useContent();
  const base = content.activities.items.map((i) => i.title);
  const items = [...base, ...base];
  return (
    <div className="relative border-y border-white/10 py-6 bg-[#050505] overflow-hidden" data-testid="marquee">
      <div className="marquee-track">
        {items.map((t, i) => (
          <span key={i} className="mx-8 inline-flex items-center gap-8 font-serif text-3xl md:text-4xl text-white/80">
            {t}
            <span className="text-electric text-lg">◆</span>
          </span>
        ))}
      </div>
    </div>
  );
};
